import {ref, computed, onMounted, type Ref} from 'vue'
import { resourcesService } from '@/api/resources.service'
import type { Praeparat } from '@/types/otc/praeparat'

export function useProductImage(praeparat: Ref<Praeparat | null>) {
    const baseUrl = ref<string>('')

    const imageKey = computed(() => praeparat.value?.bildKey ?? '')

    const bgColor = computed(() => {
        const raw = praeparat.value?.otcKategorie?.farbe ?? ''
        return raw.replace(/^#/, '')
    })

    const productImageUrl = computed(() => {
        if (!baseUrl.value || !imageKey.value) return ''

        // TODO Wieder entfernen nur für Lokale Entwicklung (Manu)
        let apiUrl = baseUrl.value
        if (apiUrl.startsWith('http://localhost:57444')) {
            apiUrl = apiUrl.replace('http://localhost:57444', 'https://fachwelt.aliud.de')
        }

        const url = new URL(apiUrl, window.location.origin)
        url.searchParams.set('key', imageKey.value)
        return url.toString()
    })

    function buildImageUrl(width: number = 405, quality: number = 100, transparent: boolean = false, bgColor?: string) {
        if (!productImageUrl.value) return ''

        const params = new URLSearchParams()
        params.set('width', width.toString())
        params.set('quality', quality.toString())
        params.set('transparent', transparent.toString())

        if (bgColor) {
            params.set('bgColor', bgColor)
        }

        return `${productImageUrl.value}&${params.toString()}`
    }

    async function initializeImageApi() {
        try {
            baseUrl.value = await resourcesService.publicImageApiUrl()
        } catch (err) {
            console.error('[ProductImage] publicImageApiUrl', err)
        }
    }

    onMounted(initializeImageApi)

    return {
        baseUrl,
        imageKey,
        bgColor,
        productImageUrl,
        buildImageUrl
    }
}